export default "__VITE_PUBLIC_ASSET__8a97ca14__"